/**
 * Stress-Test board as its own route (`/workshop/:id/stress-test`)
 * rather than a Dialog overlaid on the WorkshopDashboard grid. The
 * dashboard body behind a Dialog kept bleeding through the backdrop
 * (UAT: "should not be overlayed onto the workshop page"), so this
 * mounts `<StressTest>` full-bleed in the routed `<main>` under
 * HudHeader.
 *
 * The bottom WorkshopNavigator was originally left off this page (UAT:
 * bottom stepper must not show on activity boards), but Patrick asked
 * to be able to switch which workshop's activity is loaded without
 * leaving the board — so it's back, sized the same way
 * `WorkshopDashboard` sizes it: the board sits in a `flex-1 min-h-0`
 * row above it so the navigator keeps its own footer height instead of
 * being squeezed by the board.
 */

import { Navigate, useNavigate, useParams } from "react-router-dom";
import { WorkshopNavigator } from "@/components/shell/WorkshopNavigator";
import { WORKSHOPS } from "@/content/workshops";
import { StressTest } from "./StressTest";

export function StressTestPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const workshop = WORKSHOPS.find((w) => w.id === id);

  if (!workshop) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <div className="min-h-0 flex-1">
        <StressTest
          workshopId={workshop.id}
          onClose={() => navigate(`/workshop/${workshop.id}`)}
        />
      </div>
      <WorkshopNavigator />
    </div>
  );
}
